export default "<h2 align=\"center\">People Server to Exchequer</h2>\n<p align=\"center\">Page will be available soon!</p>\n";